import React, { Fragment } from "react";
import { CardHeader } from "reactstrap";
import { H3, P } from "../AbstractElements";
import { CommonCardHeaderProp } from "../Type/CommonComponant";

const CommonCardHeader = ({ title, span, className,text,titleClass,icon }: CommonCardHeaderProp) => {
  return (
    <CardHeader className={className ? className : "card-no-border pb-0"}>
      <H3 className={`mb-0 ${titleClass?"text-white":""}`}>{icon}{title}</H3>
      {span && (
        <P className="f-m-light mt-1">
          {span.map((data, index) => (
            <Fragment key={index}>
              {data?.text} {data.code && <code>{data.code}</code>} {data.mark && <mark>{data.mark}</mark>}
            </Fragment>
          ))}
        </P>
      )}
      {text && <span>{text}</span>}
    </CardHeader>
  );
};

export default CommonCardHeader;
